// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"693":"3f9fd194","710":"dd97699b","845":"7c6148b6","983":"9b8a7d58"}[chunkId] + ".chunk.js";
};